/**
 * * Модель запроса на получение задачи Weeek
 */
export default class WeeekTaskGetRequest  {
	/**
	 * * Номер задачи на weeek
	 */
	WeeekTaskId?: number;
	/**
	 * * Адрес ссылки к задаче
	 */
	WeeekTaskUrl!: string;
	/**
	 * * Номер проекта
	 */
	ProjectId!: number;
	/**
	 * * Номер очереди
	 */
	QueueTaskId!: string;
	constructor(obj?: Partial<WeeekTaskGetRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
